<div class="offcanvas-header">
    <h5 class="offcanvas-title"><b>Unblock:</b> {{partnerName}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="offcanvas-body">
    <p>Do you want to unblock <strong>{{ partnerName }}</strong>?</p>
  </div>
  <div class="offcanvas-footer d-flex justify-content-end align-items-center p-3">
<button class="secondaryBtn me-2" (click)="cancel()">Cancel</button>
<button class="primaryBtn" (click)="confirm()">Unblock</button>
</div>